<template>
    <v-container fluid>
        <TopBar></TopBar>
        <SideNavigation v-model="filters" :filters="filters"></SideNavigation>
        <v-img
            v-if="isLoading"
            :aspect-ratio="1"
            width="100"
            src="/Content/img/loading.gif"
            class="loading-icon"
        />
        <Statistics v-if="!isLoading" :statistics="statistics"></Statistics>
        <DataTable
            v-if="!isLoading"
            :subscriptions="subscriptions"
            :total-subscriptions="totalSubscriptions"
            :filters="filters"
        ></DataTable>
    </v-container>
</template>

<script>
import Axios from 'axios';
import TopBar from '@/views/LayoutElement/top-bar';
import SideNavigation from '@/views/LayoutElement/side-navigation';
import Statistics from '@/views/Statistics/statistics';
import DataTable from '@/views/DataTable/data-table';
import { EventBus } from '../components/helpers/eventbus';
export default {
    components: {
        TopBar,
        SideNavigation,
        Statistics,
        DataTable
    },

    data() {
        return {
            filters: [],
            active: [],
            open: [],
            subscriptions: [],
            statistics: [],
            isFirstRun: true,
            isLoading: true,
            totalSubscriptions: -1
        };
    },
    created() {
        this.updateFilters();
    },
    mounted() {
        EventBus.$on('update-subscriptions', () => {
            this.updateFilters();
        });
        EventBus.$on('reset-filters', () => {
            this.resetFilters();
        });
    },
    methods: {
        updateFilters() {
            this.isLoading = true;
            Axios({
                method: 'post',
                url: '/api/data/ApplyFilters',
                data: {
                    filters: this.filters
                }
            }).then(response => {
                if (this.isFirstRun) {
                    this.filters = response.data.filters;
                    this.isFirstRun = false;
                }
                this.subscriptions = response.data.subscriptions;
                this.statistics = response.data.statistics;
                this.totalSubscriptions = response.data.totalSubscriptions;
                this.isLoading = false;
            });
        },
        resetFilters() {
            this.isLoading = true;
            Axios({
                method: 'post',
                url: '/api/data/ApplyFilters',
                data: {
                    filters: []
                }
            }).then(response => {
                this.filters = response.data.filters;
                this.subscriptions = response.data.subscriptions;
                this.statistics = response.data.statistics;
                this.totalSubscriptions = response.data.totalSubscriptions;
                this.isLoading = false;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.v-overlay {
    pointer-events: auto;
    -ms-touch-action: auto;
    touch-action: auto;
}

.loading-icon {
    margin: auto;
}
</style>
